import { render, staticRenderFns } from "./MailchimpForm.vue?vue&type=template&id=686946c0&scoped=true&lang=html&"
import script from "./MailchimpForm.vue?vue&type=script&lang=js&"
export * from "./MailchimpForm.vue?vue&type=script&lang=js&"
import style0 from "./MailchimpForm.vue?vue&type=style&index=0&id=686946c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686946c0",
  null
  
)

export default component.exports